/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2MedicalReportClipboard/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2MedicalReportClipboard({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2MedicalReportClipboard",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 10,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2MedicalReportClipboard.Svg"
  data-view-path={viewPath}
 viewBox="0 0 10 12"
 style={{'--as-1-1wYzET': alignSelf,'--mt-2-1wYzET': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1wYzET': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1wYzET': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1wYzET': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1wYzET': opacity,'--w-10-1wYzET': typeof width === 'number' ? `${width}px` : width,'--h-11-1wYzET': typeof height === 'number' ? `${height}px` : height,'--f-12-1wYzET': fill,'--a-7-1wYzET': isAnimated ? animation : "none",'--sd-8-1wYzET': isAnimated ? strokeDashoffset : 0,'--sd-9-1wYzET': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2MedicalReportClipboard.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2.786.857c0-.473.383-.857.857-.857h2.571c.474 0 .857.384.857.857v.429a.857.857 0 01-.857.857H3.643a.857.857 0 01-.857-.857V.857zm5.357 0h.428c.71 0 1.286.576 1.286 1.286v8.571c0 .71-.576 1.286-1.286 1.286H1.286C.576 12 0 11.424 0 10.714V2.143C0 1.433.576.857 1.286.857h.428v.429c0 1.065.864 1.928 1.929 1.928h2.571a1.929 1.929 0 001.929-1.928V.857zM4.046 5.098c0-.185.15-.336.336-.336h1.093c.186 0 .336.15.336.336v1.338H7.15c.185 0 .336.15.336.336v1.093c0 .186-.15.336-.336.336H5.81V9.54c0 .185-.15.336-.336.336H4.382a.336.336 0 01-.336-.336V8.2H2.708a.336.336 0 01-.336-.336V6.772c0-.186.15-.336.336-.336h1.338V5.098z"
 style={{'--f-12-1wYzET': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}